import type { ComponentType } from 'react';
import { Terminal } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { nativeEditorWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  nativeEditorWeb,
  {
    NativeEditorButton: () =>
      import('./NativeEditorButton') as unknown as Promise<Record<string, ComponentType>>,
  },
  {
    icons: { Terminal },
  },
);
